import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { getFormattedDateIso8601, parseLocalCalendarDate } from 'utils/formatter';

import { TextField } from 'components';

export const toFilterDateIso = (newDate, bound = 'start') => {
  const date = parseLocalCalendarDate(newDate);
  if (!date) return undefined;
  return getFormattedDateIso8601(date, bound);
};

function DateInput({ id, value, label, onChange, error, size = 'small', fullWidth = true }) {
  const [picked, setPicked] = useState(null);

  const handleChange = newDate => {
    setPicked({ date: newDate, queryValue: value });
    onChange?.(newDate);
  };

  const wasRefused = !!error && picked?.queryValue === value;

  const pickerValue = parseLocalCalendarDate(wasRefused ? picked.date : value);

  return (
    <TextField
      id={id}
      value={pickerValue}
      label={label}
      envelope="date"
      onChange={handleChange}
      size={size}
      margin="none"
      error={!!error}
      helperText={error || undefined}
      fullWidth={fullWidth}
    />
  );
}

DateInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  label: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.node,
  size: PropTypes.string,
  fullWidth: PropTypes.bool,
};

export default DateInput;
